import { SUPPORTED_REDIRECTS, getEquivalenPageName } from './redirects';
import { getBestAppToRedirectTo } from './signed-in-app';
/**
 * Call redirectToEquivalentPage when you're not signed in
 * to redirect to the same page in the other app where you are most recently signed in
 *
 * This fn assumes all the apps are being set as "signed in" in the same way using storeSignedInApp and clearSignedInApp
 *
 * Each route you can redirect to should get its own function call in here
 * Each redirect fn should set window.location.href if a better page to redirect to can be found
 * Each redirect fn should do nothing if not attempting to go to a relevant page
 *
 * @returns void
*/
export const getRedirectURLToEquivalentPage = () => {
    const equivalentPageName = getEquivalenPageName();
    if (equivalentPageName) {
        const bestAppToRedirectTo = getBestAppToRedirectTo(equivalentPageName);
        const fn = SUPPORTED_REDIRECTS[equivalentPageName];
        if (fn && bestAppToRedirectTo) {
            return fn(bestAppToRedirectTo);
        }
    }
    return '';
};
